import React from 'react'
import SpawnerContext from './SpawnerContext'

export default function useSpawner () {
  return React.useContext(SpawnerContext)
}
